import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

interface Tab {
    id: number;
    view: string;
}

export function useTabNavigation(tabs: Tab[], defaultView = "grid") {
    const [selectedTab, setSelectedTab] = useState(0);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const view = queryParams.get("view-type") ?? defaultView;

        const tab = tabs.find(e => e.view === view)?.id ?? 0;
        setSelectedTab(tab);
    }, [location.search, tabs, defaultView]);

    const handleTabChange = (e: any) => {
        const index: number = e.component.option("selectedIndex");
        if (index === selectedTab) return;

        const view = tabs[index].view ?? defaultView;
        navigate({ search: `?view-type=${view}` });
        setSelectedTab(index);
    };

    return { selectedTab, handleTabChange };
}
